import {
  SET_UPLOAD_MESSAGE,
  CLOSE_UPLOAD_TASK_BOX,
  SET_UPLOAD_TASK_STATUS
} from './mutation-types.js'
export default {
  // 强制关闭 页面右下角 上传任务列表
  [CLOSE_UPLOAD_TASK_BOX] (state) {
    state.uploadTaskShow++
  },
  // 设置 历史上传 消息
  [SET_UPLOAD_MESSAGE] (state, message) {
    state.message = message || '0'
  },
  // 设置是否有上传任务正在执行
  [SET_UPLOAD_TASK_STATUS] (state, val) {
    state.hasUploadTask = val || false
  }
}

